export const cataloguesNZ =  [
  {
    title: 'Biz Collection',
    items: [
      {
        altName: '2024 Fashion Biz Catalogue',
        link: 'https://issuu.com/fashionbiznz/docs/2024_fashion_biz_-_nz?fr=xKAE9_zU1NQ',
      },
      {
        altName: '2024 Yes Chef Catalogue',
        link: 'https://issuu.com/fashionbiznz/docs/2024_yes_chef_-_aunz?fr=sNTQ2ODYyNzY2Nzg',
      },
    ],
  },
  {
    title: 'Biz Corporates',
    items: [
      {
        altName: '2024 Biz Corporates Catalogue',
        link: 'https://issuu.com/fashionbiznz/docs/2024_biz_corporates?fr=xKAE9_zU1NQ',
      },
      {
        altName: '2023 Biz Corporates Catalogue',
        link: 'https://issuu.com/fashionbiznz/docs/2023_biz_corporates?fr=sN2RlMjYyNzY2Nzg',
      },
    ],
  },
  {
    title: 'Syzmik',
    items: [
      {
        altName: '2025 Syzmik Catalogue',
        link: 'https://issuu.com/fashionbiznz/docs/2025_syzmik_-_nz_-_full-catalogue_issuu?fr=sNmU5ZDYyNzY2Nzg',
      },
      {
        altName: '2024 Syzmik Catalogue',
        link: 'https://issuu.com/fashionbiznz/docs/2024_syzmik_-_nz_-_winter?fr=xKAE9_zU1NQ',
      },
    ]
  },
  {
    title: 'Biz Care',
    items: [
      {
        altName: '2024 Biz Care Catalogue',
        link: 'https://issuu.com/fashionbiznz/docs/2024_biz_care_nz?fr=xKAE9_zU1NQ',
      },
      {
        altName: '2023 Biz Care Catalogue',
        link: 'https://issuu.com/fashionbiznz/docs/2023_biz_care_nz?fr=xKAE9_zU1NQ',
      },
    ]
  },
];

export const cataloguesAU =  [
  {
    title: 'Biz Collection',
    items: [
      {
        altName: '2024 Fashion Biz Catalogue',
        link: 'https://issuu.com/fashionbiznz/docs/2024_biz_collection_-_au?fr=xKAE9_zU1NQ',
      },
      {
        altName: '2024 Yes Chef Catalogue',
        link: 'https://issuu.com/fashionbiznz/docs/2024_yes_chef_-_aunz?fr=sNTQ2ODYyNzY2Nzg',
      },
    ],
  },
  {
    title: 'Biz Corporates',
    items: [
      {
        altName: '2024 Biz Corporates Catalogue',
        link: 'https://issuu.com/fashionbiznz/docs/2024_biz_corporates?fr=xKAE9_zU1NQ',
      },
      {
        altName: '2023 Biz Corporates Catalogue',
        link: 'https://issuu.com/fashionbiznz/docs/2023_biz_corporates?fr=sN2RlMjYyNzY2Nzg',
      },
    ],
  },
  {
    title: 'Syzmik',
    items: [
      {
        altName: '2025 Syzmik Catalogue',
        link: 'https://issuu.com/fashionbiznz/docs/2025_syzmik_-_au_-_full-catalogue_issuu?fr=sNWM5MzYyNzY2Nzg',
      },
      {
        altName: '2024 Syzmik Catalogue',
        link: 'https://issuu.com/fashionbiznz/docs/2024_syzmik_-_au_-_winter?fr=xKAE9_zU1NQ',
      },
    ]
  },
  {
    title: 'Biz Care',
    items: [
      {
        altName: '2024 Biz Care Catalogue',
        link: 'https://issuu.com/fashionbiznz/docs/2024_biz_care_au?fr=xKAE9_zU1NQ',
      },
      {
        altName: '2023 Biz Care Catalogue',
        link: 'https://issuu.com/fashionbiznz/docs/2023_biz_care_au?fr=xKAE9_zU1NQ',
      },
    ]
  },
];

export const cataloguesCA =  [
  {
    title: 'Biz Collection',
    items: [
      {
        altName: '2024 Fashion Biz Catalogue English',
        link: 'https://issuu.com/fashionbiznz/docs/2024_fashion_biz_-_ca?fr=xKAE9_zU1NQ',
      },
      {
        altName: '2024 Fashion Biz Catalogue French',
        link: 'https://issuu.com/fashionbiznz/docs/2024_fashion_biz_-_ca-fr?fr=xKAE9_zU1NQ',
      },
      {
        altName: '2023 Fashion Biz Catalogue English',
        link: 'https://issuu.com/fashionbiznz/docs/2023_fashion_biz_-_ca?fr=sNDc1OTYyNzY2Nzg',
      },
      {
        altName: '2023 Fashion Biz Catalogue French',
        link: 'https://issuu.com/fashionbiznz/docs/2023_fashion_biz_-_ca-fr?fr=sNzlkYzYyNzY2Nzg',
      },
    ],
  },
  {
    title: 'Syzmik',
    items: [
      {
        altName: '2024 Syzmik Catalogue',
        link: 'https://issuu.com/fashionbiznz/docs/2024_syzmik_-_ca_-_catalogue?fr=xKAE9_zU1NQ',
      },
    ]
  },
];
